import React from "react";
import { Route, HashRouter as Router, Switch } from "react-router-dom";

import Details from "./Details";
import KeywordSearch from "./KeywordSearch";
import List from "./List";

const RecruitRouter = () => (
  <Router>
    <Switch>
      <Route exact path="/校园招聘/">
        <List />
      </Route>
      <Route exact path="/校园招聘/查询/">
        <KeywordSearch />
      </Route>
      <Route exact path="/校园招聘/:id">
        <Details />
      </Route>
    </Switch>
  </Router>
);

export default RecruitRouter;
